import { useInfiniteQuery } from "@tanstack/react-query";
import type { UseInfiniteQueryResult } from "@tanstack/react-query";

import { listMyOrders } from "../../api/orders";
import type { OrderList, OrderListItem } from "../../api/orders";

export const myOrdersQueryKey = ["my-orders"] as const;

/** useMyOrders грузит историю заказов покупателя постранично по курсору (docs/07-miniapp-ux.md §2.7). */
export function useMyOrders(): UseInfiniteQueryResult<{ items: OrderListItem[]; hasMore: boolean }, Error> {
  return useInfiniteQuery({
    queryKey: myOrdersQueryKey,
    queryFn: ({ pageParam, signal }) => listMyOrders(pageParam, signal),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage: OrderList) => lastPage.next_cursor,
    select: (data) => ({
      items: data.pages.flatMap((page) => page.items),
      hasMore: data.pages[data.pages.length - 1]?.next_cursor !== null,
    }),
  });
}
